<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'8-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메뉴 관리 - 공지사항 관리</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminNoticeManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
            <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_notice,
  delete_notice
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminNoticeManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminNoticeManagementAdd?notice_ID=${this.tabulator.getSelectedData()[0].notice_ID}`
      }
    },
    delete_row: function () {
      let temp_delete_array = []
      this.tabulator.getSelectedData().forEach((element) => {
        temp_delete_array.push(element.notice_ID)
      })
      delete_notice(temp_delete_array).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.')
        } else {
          alert('삭제가 완료 되었습니다.')
          window.location.reload()
        }
      })
    }
  },
  mounted () {
    get_notice().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        columns: [
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'ID', field: 'notice_ID', headerSort: false},
          {title: '타이틀', field: 'notice_title', headerSort: false},
          {title: '상단공지', field: 'notice_top_status', headerSort: false},
          {title: '작성자', field: 'notice_write', headerSort: false},
          {title: '조회수', field: 'notice_views', headerSort: false},
          {title: '노출여부', field: 'notice_status', headerSort: false},
          {title: '댓글수', field: 'notice_comment_count', headerSort: false},
          {title: '작성일', field: 'notice_registe', headerSort: false},
          {title: '수정일', field: 'notice_modified', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CommunityManagement/AdminNoticeManagement.vue